import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'magnific-popup';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import '../../../../stylesheets/react_popup_for_sp.scss';

import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';

const PopupForSP = props => {
  const [currentSectionId, setCurrentSectionId] = useState(1);
  const [selectedCount, setSelectedCount] = useState(0);

  const computeCurrentItemTypes = currentSectionId => {
    return props.itemTypes.filter(itemTypes => itemTypes.sectionTypeId === currentSectionId);
  };
  const memoizedCurrentItemTypes = useMemo(() => computeCurrentItemTypes(currentSectionId), [currentSectionId]);
  const sliderRef = useRef(); // for Slick

  useEffect(() => {
    // Slickを適応させる
    $(sliderRef.current).slick({
      dots: false,
      pauseOnHover: false,
      pauseOnDotsHover: true,
      swipe: false,
      accessibility: false,
      arrows: false,
    });

    const handleKeyDown = event => {
      const tabKeyCode = 9;
      if (event.keyCode === tabKeyCode) {
        event.preventDefault();
      }
    };

    // Slick内でTabキーを押下するとレイアウトが崩れるため、無効化を行う
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      // 不必要になったslickを外す
      $(sliderRef.current).slick('unslick');
      // Tab無効化を解除する
      document.removeEventListener("keydown", handleKeyDown);
    }
  }, []);

  /**
   * slickのページ移動を行う
   * page=[0,1,2...] (page=slickのページ番号)
   * @param page <code>page >= 0</code>
   */
  const slickGoTo = page => {
    $(sliderRef.current).slick('slickGoTo', page);
  };

  /**
   * 初期の大項目が表示される
   */
  const SectionList = () => {
    const classes = sectionTypeId => {
      const isSelectedSection = props.selectedSectionIds.some(selectedSectionId => selectedSectionId === sectionTypeId);
      return isSelectedSection ? "checked" : undefined;
    };

    const onClickSectionButton = sectionTypeId => {
      setCurrentSectionId(sectionTypeId);
      slickGoTo(1);
      // 大カテゴリ選択時に、項目のスクロールを初期化する
      $('.list_body').scrollTop(0);
    };

    return props.sectionTypes.map(sectionType =>
      <li key={sectionType.id}
          className={classes(sectionType.id)}
          onClick={() => onClickSectionButton(sectionType.id)}>
        {sectionType.name}
      </li>
    );
  };

  /**
   * 全選択を行う
   * @returns {null|*}
   * @constructor
   */
  const AllSectionItemSelector = () => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
      const isSelectedAll =
        memoizedCurrentItemTypes.every(itemType => props.selectedIds.some(selectedId => selectedId === itemType.id));

      setChecked(isSelectedAll);
      setSelectedCount(props.selectedIds.length);
    }, [memoizedCurrentItemTypes, props.selectedIds]);

    const onClickItem = () => {
      props.onClickAllSelectBySectionUnit(currentSectionId);
    };

    if (props.needSelectedAllButton) {
      return (
        <li className={checked ? "checked" : undefined} onClick={onClickItem}>
          <input type="checkbox" className="popup-checkbox-input"/>
          <label>{props.sectionTypes.filter(sectionType => sectionType.id === currentSectionId)[0].name}</label>
        </li>
      );
    } else {
      return null;
    }
  };

  /**
   * 各項目をクリックした後の項目が表示される
   */
  const ItemList = () => {
    const existsInSelectedIds = itemTypeId => {
      return props.selectedIds.some(selectedId => selectedId === itemTypeId);
    };

    const onClickItem = itemTypeId => {
      if (props.recruitmentPrTypes) {
        // 5つ以上の項目を選択できないようにする
        if (selectedCount >= 5 && !existsInSelectedIds(itemTypeId)) {
          return;
        }
        // 項目をクリックすると選択された数を更新
        const newCount = existsInSelectedIds(itemTypeId) ? selectedCount - 1 : selectedCount + 1;
        setSelectedCount(newCount);
      }
      props.onClickItem(itemTypeId);
    };

    const onChangeItem = event => {
      event.target.checked = !event.target.checked
    };

    return props.itemTypes
      .filter(itemType => itemType.sectionTypeId === currentSectionId)
      .map(itemType => {
        return (
            <li className={existsInSelectedIds(itemType.id) ? "checked" : undefined}
                onClick={() => onClickItem(itemType.id)} key={itemType.id}>
              <input
                type="checkbox"
                name="check-list"
                className="popup-checkbox-input business_type_ids"
                checked={existsInSelectedIds(itemType.id)}
                onChange={onChangeItem}
              />
              <label htmlFor={"business-type" + itemType.id}
                     id={"business-type-label" + itemType.id}>{itemType.name}</label>
            </li>
        );
      });
  };

  const onClickSelectedButton = () => {
    props.onClosePopup();
  };

  const onClickBackButton = () => {
    slickGoTo(0);
  };

  const Message = () => {
    if (props.isLimitedItem) {
      return <div className="sp popup_message"><p>{props.popupOptions.messages.sp.limitedItem}</p></div>
    } else {
      return null;
    }
  };

  const RemainingCount = () => {
    if (props.recruitmentPrTypes) {
      return <span  className="select_count_message">あと{Math.max(0, 5 - selectedCount)}点</span>
    } else {
      return null;
    }
  };
  const PrMessages = () => {
    if (props.recruitmentPrTypes) {
      return <div className="recruitment_pr_message"><p>{props.popupOptions.prMessages.sp.limitedItem }</p></div>
    } else {
      return null;
    }
  };

  return (
    <>
      <ul className={"sp header" + `${props.isLimitedItem ? " pd_btm_1em" : ""}`}>
        <li>
          <h1>{props.popupOptions.title}</h1>
          <Message/>
        </li>
      </ul>
      <ul className={"sp header" + `${props.recruitmentPrTypes ? "recruitment_pr_wrapper" : ""}`}>
        <li><RemainingCount/></li>
        <li><PrMessages/></li>
      </ul>
      <div className="sp popup_for_sp">
        <div ref={sliderRef} className="popup_for_sp">
          <div className="main_page1">
            <ul>
              <SectionList/>
            </ul>
          </div>
          <div className="main_page2">
            <div>
              <a href="#" tabIndex="-1" onClick={onClickBackButton}>戻る</a>
            </div>
            <div className="list_body">
              <ul>
                <AllSectionItemSelector/>
                <ItemList/>
                <li className="cols2 space"/>
              </ul>
            </div>
          </div>
        </div>
        <div className="btn_area">
          <props.ButtonArea
            onClickCloseButton={props.onClosePopup}
            onClickSubmitButton={props.onSubmit}
          />
        </div>
      </div>
    </>
  );
};

PopupForSP.propTypes = {
  sectionTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sort: PropTypes.number,
    }).isRequired
  ),
  itemTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sort: PropTypes.number,
      sectionTypeId: PropTypes.number
    }).isRequired
  ),
  isLimitedItem: PropTypes.bool,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  selectedSectionIds: PropTypes.arrayOf(PropTypes.number),
  needSelectedAllButton: PropTypes.bool,
  onClickItem: PropTypes.func,
  onClosePopup: PropTypes.func,
  onSubmit: PropTypes.func,
  ButtonArea: PropTypes.func.isRequired,
  onClickAllSelectBySectionUnit: PropTypes.func,
  popupOptions: PropTypes.object,
  recruitmentPrTypes: PropTypes.bool,
};

export default PopupForSP;